import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import AdminModal from '../../reusable/admin-modal/admin-modal.component';
import Button from '../../reusable/button/button.component';
import Spinner from '../../reusable/spinner/spinner.component';

import { ToastContext } from '../../../contexts/toast.context';

import Client from '../../../tools/client';

import {
  ButtonContainer,
  ButtonRowContainer,
  DeleteButton,
  InputContainer,
  MainContainer,
  ProductContent,
  UpdateInput,
  UpdateLabel,
  UpdateTextarea,
  UpdateSelect,
  UpdateOption,
} from './update-fulfillment.styles';

const client = new Client();

const UpdateFulfillment = ({ fulfillment, setShowUpdate, getFulfillment, afterDeleteFulfillment }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [trackingNumber, setTrackingNumber] = useState(fulfillment.trackingNumber || '');
  const [shippedAt, setShippedAt] = useState(fulfillment.shippedAt || '');
  const [deliveredAt, setDeliveredAt] = useState(fulfillment.deliveredAt || '');

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const { errorToast, successToast } = useContext(ToastContext);

  const confirmDelete = () => {
    setShowDeleteModal(true);
  };

  const deleteFulfillment = async () => {
    const res = await client.deleteFulfillmentById(fulfillment.id);
    if (res.status === 403) {
      setShowDeleteModal(false);
      errorToast(res.message);
      return;
    }
    
    await afterDeleteFulfillment();
  };

  const updateFulfillment = async () => {
    setLoading(true);

    const data = {
      trackingNumber,
      shippedAt: shippedAt || null,
      deliveredAt: deliveredAt || null,
    };

    const res = await client.updateFulfillment(fulfillment.id, data);
    if (res.status === 400) {
      errorToast(res.message);
      setLoading(false);
      return;
    }

    successToast('Fulfillment Updated');
    await getFulfillment();
    setLoading(false);
    setShowUpdate(false);
  };

  return (
    <MainContainer>
      <AdminModal
        show={showDeleteModal}
        setShow={setShowDeleteModal}
        title={'Delete Fulfillment'}
        image={''}
        message={`Are you sure you want to delete fulfillment ${fulfillment.id}? This cannot be undone.`}
        action={deleteFulfillment}
        actionText={'Delete'}
      />

      {loading ? (
        <Spinner />
      ) : (
        <>
          <ProductContent>
            <InputContainer>
              <UpdateLabel>Tracking Number:</UpdateLabel>
              <UpdateInput value={trackingNumber} onChange={(e) => setTrackingNumber(e.target.value)} />
            </InputContainer>
            <InputContainer>
              <UpdateLabel>Shipped At:</UpdateLabel>
              <UpdateInput type="datetime-local" value={shippedAt} onChange={(e) => setShippedAt(e.target.value)} />
            </InputContainer>
            <InputContainer>
              <UpdateLabel>Delivered At:</UpdateLabel>
              <UpdateInput type="datetime-local" value={deliveredAt} onChange={(e) => setDeliveredAt(e.target.value)} />
            </InputContainer>
          </ProductContent>

          <ButtonContainer>
            <DeleteButton onClick={() => confirmDelete()}>DELETE</DeleteButton>
            <ButtonRowContainer>
              <Button onClick={() => setShowUpdate(false)}>Cancel</Button>
              <Button onClick={() => updateFulfillment()}>Update</Button>
            </ButtonRowContainer>
          </ButtonContainer>
        </>
      )}
    </MainContainer>
  );
};

export default UpdateFulfillment;